import { AlertCircle } from 'lucide-react'

interface ContentLayoutProps {
  variant?: 'content'
  children: React.ReactNode
  /** Error message displayed as a banner above content */
  error?: string | null
  /** Max width class for the content wrapper (default: max-w-4xl) */
  maxWidth?: string
  /** Center content vertically (useful for ProcessingScreen) */
  centerVertically?: boolean
}

interface RawLayoutProps {
  variant: 'raw'
  children: React.ReactNode
}

type OnboardingLayoutProps = ContentLayoutProps | RawLayoutProps

export function OnboardingLayout(props: OnboardingLayoutProps) {
  // translate="no" prevents browser translation (Google Translate, etc.) from
  // wrapping text nodes in <font> tags, which corrupts React's DOM diffing and
  // causes "Failed to execute 'removeChild'" errors on state updates.
  if (props.variant === 'raw') {
    return (
      <div translate="no" className="relative flex min-h-screen bg-[#111111]">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#f97316]/10 via-background to-background" />
        <div className="relative flex flex-1">{props.children}</div>
      </div>
    )
  }

  const { children, error, maxWidth = 'max-w-4xl', centerVertically } = props

  return (
    <div translate="no" className="relative flex min-h-screen flex-col bg-[#111111]">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#f97316]/10 via-background to-background" />

      <div className="relative px-12 pt-12">
        <img src="/seedforge-logo.svg" alt="SeedForge" className="h-8" />
      </div>

      <div
        className={`relative flex flex-1 ${centerVertically ? 'items-center' : ''} justify-center px-6 py-10`}
      >
        <div className={`w-full ${maxWidth} space-y-10`}>
          {error && (
            <div className="flex items-center gap-3 rounded-2xl border border-red-500/20 bg-red-500/[0.06] px-5 py-4">
              <AlertCircle className="size-5 shrink-0 text-red-400" />
              <p className="flex-1 text-sm text-red-300">{error}</p>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}
